import { render, staticRenderFns } from "./BildungsgangVerrechnungspositionen.vue?vue&type=template&id=14fb4807&scoped=true"
import script from "./BildungsgangVerrechnungspositionen.vue?vue&type=script&lang=js"
export * from "./BildungsgangVerrechnungspositionen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fb4807",
  null
  
)

export default component.exports